import { useSelector } from "react-redux";

import Map from "./Map";
import Loading from "../main/Loading";

export const MapView = ({ currentSize }) => {
  const isSearching = useSelector((state: any) => state.taskReducer.get("pending"));
  const items = useSelector((state: any) => state.taskReducer.getIn(["MAP", "children"]));
  return (
    <>
      {isSearching && <Loading />}
      <Map
        items={items}
        appHeight={currentSize.height}
        center={{ latitude: 45.496162, longitude: -73.57993 }}
        onHoverMarker={() => {}}
      />
    </>
  );
};

export default MapView;
